import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

//自定义指令
// 前端工程自动化
// require.context函数执行后返回的是一个函数,并且这个函数有3个属性
const requireCommon = require.context("./commonJs", false, /.js$/);
const requireDirectives = require.context("./directives", true, /.js$/);

const install = Vue => {
  //添加实例方法 
  requireCommon.keys().forEach(r => {
    let name = r.replace(/^\.\//, "").replace(/\.\w+$/, "");

    
    let commonName = "$" + [name];

       let module = requireCommon(r).default

      //  if(typeof module =='function'){
      //   Vue.prototype[commonName] = requireCommon(r).default;
      //  }else if(typeof module =='object'){
      //    Vue.prototype[commonName] = requireCommon(r).default;
      // }
      
      Vue.prototype[commonName] = requireCommon(r).default;


  })

 //批量处理自定义指令脚本
 requireDirectives.keys().forEach(directives => {
  let name = directives.replace(/^\.\//, "").replace(/\.\w+$/, "");
  Vue.directive(name, requireDirectives(directives).default);
  
})

}


export default install

